import moment from 'moment'

export type OperationHours = {
  interval?: string
  hours?: { isOpen: boolean }[]
}

export type DateAvailabilityOptions = {
  maxValidFrom: Date
  minValidTo: Date
  operationHours?: OperationHours
}

/**
 * Mirrors the original day-filter logic from the booking form: a date is
 * bookable when it falls inside the service validity window and its weekday is
 * marked open in the operation hours for the current location mode.
 */
export function isDateAvailable(date: Date, options: DateAvailabilityOptions): boolean {
  const { maxValidFrom, minValidTo, operationHours } = options
  const current = moment(date)

  if (current.isBefore(moment(maxValidFrom), 'day')) return false
  if (current.isAfter(moment(minValidTo), 'day')) return false

  const dayOfWeek = current.day()
  return operationHours?.hours?.[dayOfWeek]?.isOpen === true
}

/**
 * Walks the validity window from the earliest allowed day and returns the first
 * bookable date, or null when nothing in the window is open.
 */
export function firstAvailableDate(options: DateAvailabilityOptions): Date | null {
  const { maxValidFrom, minValidTo } = options
  const cursor = moment(maxValidFrom).startOf('day')
  const end = moment(minValidTo).startOf('day')

  while (cursor.isSameOrBefore(end, 'day')) {
    const candidate = cursor.toDate()
    if (isDateAvailable(candidate, options)) return candidate
    cursor.add(1, 'day')
  }

  return null
}
